<template>
   
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header text-center">
            <slot name="header">
              <h1>cc-pronto4</h1>
              <div>powerd by assley</div>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <form>
                <div class="form-group">
                  <label for="username">Name:</label>
                  <input type="" class="form-control" id="username" placeholder="Username" autocomplete="off" v-model="login.username" @keyup.enter="onLogin">
                </div>
                <div class="form-group">
                  <label for="password">Passwort:</label>
                  <input type="password" class="form-control" id="password" placeholder="Password" autocomplete="off"  v-model="login.password" @keyup.enter="onLogin">
                </div>
                <div class="form-group">
                  <label for="place">Platz/ACD-Login (optional):</label>
                  <input type="" class="form-control" id="place" placeholder="Nebenstelle" v-model="login.place"  @keyup.enter="onLogin">
                </div>
              </form>
            </slot>
          </div>

          <div class="modal-footer">
             <h4 v-show="errMsg" class="alert alert-danger">{{errMsg}}</h4>

            <slot name="footer">
                <button type="" class="btn btn-primary btn-block" @click="onLogin">Login</button>
            </slot>
          </div>
          
        </div>
      </div>
    </div>
  </transition>

</template>



<script>

import bus from './common/bus'

export default {
  
  data () {
    return {
      
      login: {
        username: '',
        password: '',
        place: '',
      },
      errMsg: '',
    }
  },
  
  
  created: function () {
  },
  
  
  
  methods: {

    onLogin: function () {
      this.$http.post(bus.config.path + '/login/usercallcenter', this.login).then((response) => {
        if(response.data.result != 200){
          // Login fehlerhaft
          console.error('login:onLogin: != 200');
          console.log(JSON.stringify(response.data, null, 2));
          this.errMsg = "Anmeldung fehlgeschlagen";
        }else{
          let loginData = response.data;
          loginData.acdKey = this.login.place;
          bus.setLogin(loginData);
          this.reset();
        }
        //console.log('login:login:');
        //console.log(JSON.stringify(response.data.result, null, 2));
      }, (response) => {
      // error callback
      });
    },
    
    reset: function () {
      this.login.username = '';
      this.login.password = '';
      this.login.place = '';
      this.errMsg = '';
    },
    

  }

}
  
</script>



<style scoped>

 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .1);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .5s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  margin: 20px 0;
}

.modal-footer {
  margin-top: 0px;
  padding-top: 00px;
  border-top: 0px solid lightgray;
  text-align: center;
}

  .modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

  

</style>



// WEBPACK FOOTER //
// Login.vue?a1a03c9c